import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { store } from './store'
import App from './App'
import { DynamicThemeProvider } from './theme/DynamicThemeProvider'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <DynamicThemeProvider>
          <App />
        </DynamicThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
)
